export const property = {
    gamefi: "Akun GameFi",
    mc_official_verify_unofficial: "Saluran tidak diverifikasi secara resmi",
    mc_official_verify_official: "Resmi",
    mc_official_verify_fotter_tip_1:
        "Peringatan risiko tentang pencegahan penipuan online/telepon oleh oknum yang menyamar sebagai staf resmi Biking",
    mc_official_verify_fotter_tip_2:
        "Pernyataan tegas dan peringatan risiko tentang kewaspadaan terhadap penipuan oleh pihak yang menyalahgunakan nama 'Biking'",
    mc_official_verify_modal_tip_1: "Kueri Anda 【{query}】 dikonfirmasi sebagai saluran resmi Biking",
    mc_official_verify_modal_tip_3: "Harap verifikasi kebenaran dan format informasi yang Anda masukkan:",
    mc_official_verify_modal_tip_4: "Nomor telepon: xx-xxxxxxxxx",
    mc_official_verify_modal_type_email: "Email",
    mc_official_verify_modal_type_domain: "URL",
    mc_official_verify_modal_type_channel: "Saluran",
    mc_official_verify_input_placeholder: "Silakan masukkan informasi dan format yang benar untuk verifikasi",
    mc_official_verify_head_title: "Saluran Verifikasi Resmi Biking Exchange | Biking Exchange",
    mc_official_verify_head_description: "Saluran Verifikasi Resmi Biking Exchange",
    mc_official_verify_title: "Saluran Verifikasi Resmi",
    mc_official_verify_discription_new: "Untuk menghindari kerugian aset akibat phishing dan penipuan online, Anda dapat memverifikasi di halaman ini apakah URL, alamat email, nomor telepon, atau akun media sosial seperti Twitter, Telegram adalah saluran terverifikasi resmi Biking.",
    mc_official_verify_fotter_tip_3: "Wajib dibaca pengguna Biking: Panduan Pencegahan Penipuan, Waspada Peningkatan Metode Penipuan!",
    mc_unofficial_verify_modal_tip_1: "Kueri Anda 【{query}】 bukan saluran resmi Biking",
    mc_official_verify_discription: "Untuk mencegah penipuan oleh oknum yang menggunakan nama Biking Global, Anda dapat mengonfirmasi melalui halaman ini apakah telepon, WeChat, dll. yang menghubungi Anda adalah saluran resmi Biking",
    mc_official_head_title1: "Verifikasi Saluran, Berita, dan Publikasi Resmi Biking",
    mc_official_head_keywords1: "Verifikasi Biking, Berita Biking, Akun Resmi Biking",
    mc_official_head_description1: "Pastikan keaslian saluran Biking. Gunakan alat verifikasi resmi kami untuk mengonfirmasi keabsahan saluran, berita, dan publikasi terkait Biking.",
    mc_official_verify_verified_title: "Saluran Terverifikasi Resmi",
    mc_official_verify_modal_tip_5: "Telegram/X/Facebook/Youtube：@xxxxx (dengan simbol @)",
    mc_official_verify_modal_tip_6: "TikTok/Instagram：xxxx (tanpa simbol @)",
    mc_official_verify_modal_tip_7: "Discord：xxxx#xxxx (tanpa simbol @)",
    mc_official_verify_modal_tip_8: "Linkedin/Grup Telegram/Medium/Reddit：https://xxxxx (tautan situs web)",
    mc_official_verify_modal_tip_9: "Jika Anda memiliki pertanyaan tentang format informasi, silakan hubungi layanan pelanggan online kapan saja.",
    mc_official_verify_modal_tip_10: "*Harap jangan berikan informasi akun dan kata sandi Anda kepada siapa pun.",
    mc_official_verify_modal_tip_11: "*Waspada penipuan, berhati-hatilah dalam beroperasi.",
    tagtip: "Jika platform penyetoran tidak memerlukan pengisian Comment, item ini dapat dikosongkan",
    tag: "Silakan masukkan Comment",
    qbcbcg: "Harap salin alamat TON dan comment secara bersamaan untuk memastikan penyetoran berhasil",
    qsrzqje: "Silakan masukkan jumlah yang benar",
    games: "Akun Game",
    cbxz: "Pemberitahuan Setor Koin Ethereum(ERC20)",
    tbxz: "Pemberitahuan Penarikan Ethereum(ERC20)",
    ctbzysx: "Harap dicatat, setiap transfer kontrak pintar resmi FUFU akan dikenakan biaya tambahan 2%.",
    dzcw: "Alamat salah",
    czqkqrs: "Jumlah Konfirmasi Blok Penyimpanan",
    mc: "Nama",
    cjsj: "Waktu Dibuat",
    lx: "Tipe",
    sl: "Jumlah",
    cwjl: "Catatan Keuangan",

    ylzh: "Laba",
    ddtx: "Menunggu Penarikan",
    txcg: "Penarikan Berhasil",
    yhcx: "Dibatalkan Pengguna",
    qbcbjl: "Semua Riwayat Setor Koin",

    zczl: "Ikhtisar Aset",
    zjzh: "Akun Dana",
    mbzh: "Akun Beli Koin",
    xhzh: "Akun Spot",
    hyzh: "Akun Kontrak",
    lczh: "Akun Keuangan",
    gdzh: "Akun Copy Trading",
    giftzh: "Akun Bonus",
    bwzh: "Kartu Biking",
    mozh: "Akun Simulasi",
    mnhy: "Kontrak Simulasi",
    sxffy: "Komisi Sistem",
    kt: "Airdrop",
    xtkc: "Dikurangi Sistem",
    zcfb: "Distribusi Aset",
    zcdt: "Dinamika Aset",
    zh: "Akun",
    zc: "Aset",
    czjl: "Riwayat Setor",
    txls: "Riwayat Penarikan",
    hzjl: "Riwayat Transfer",
    mmjl: "Riwayat Beli/Jual",
    cb: "Setor Koin",
    tx: "Penarikan",
    hz: "Transfer",
    mb: "Beli Koin",
    jy: "Trading",
    zwsj: "Belum Ada Data",
    ckqb: "Lihat Semua",

    // table
    bz: "Mata Uang",
    qc: "Nama Lengkap",
    zhze: "Total Akun",
    syzc: "Aset Tersisa",
    djzc: "Aset Beku",
    cz: "Operasi",
    sl: "Jumlah",
    cbdz: "Alamat Setor Koin",
    sj: "Waktu",
    zt: "Status",
    ms: "Deskripsi",
    hzfx: "Arah Transfer",
    hzse: "Jumlah Transfer",
    txdz: "Alamat Penarikan",
    sxf: "Biaya",
    ddh: "Nomor Pesanan",
    zj: "Harga Total",
    dj: "Harga Satuan",
    jysl: "Jumlah Trading",
    jydx: "Rekan Trading",
    zhqy: "Ekuitas Akun",
    zhqytips: "Ekuitas Akun = Margin Tersedia + Margin Posisi",
    kybzj: "Margin Tersedia",
    kybzjtips: "Margin yang dapat digunakan untuk open posisi dan transfer keluar",
    cwbzj: "Margin Posisi",
    cwbzjtips: "Margin yang digunakan untuk mempertahankan posisi yang ada",

    // search
    srbz: "Silakan masukkan mata uang yang sesuai",
    ycxzc: "Sembunyikan Aset Kecil",
    sy: "Semua",
    qb: "Semua",
    qx: "Pilih Semua",
    zhi: "Hingga",
    ksrq: "Tanggal Mulai",
    jsrq: "Tanggal Selesai",
    cx: "Cari",
    dc: "Ekspor",
    zjqt: "7 Hari Terakhir",
    zjygy: "1 Bulan Terakhir",
    qbsj: "Semua Waktu",
    usdt: "USDT",
    ddlx: "Tipe Pesanan",
    gm: "Beli",
    cs: "Jual",

    // recharge
    czxq: "Detail Setor",
    usdtcbjl: "Riwayat Setor Koin {coinName}",
    cbsl: "Jumlah Setor Koin",
    cbzt: "Status Setor Koin",
    crdbz: "Silakan pilih mata uang yang ingin Anda setor",
    tqdbz: "Silakan pilih mata uang yang ingin Anda tarik",
    rmbz: "Mata Uang Populer",
    qxz: "Silakan Pilih",
    cbwl: "Jaringan Setor Koin",
    cbtips: "Harap pastikan Anda telah memilih jaringan yang sama dengan platform penarikan untuk menyetor koin, jika tidak akan menyebabkan kerugian aset.",
    txfs: "Metode Penarikan",
    lstx: "Penarikan On-Chain",
    xyb: "Lanjut",
    yxzdq: "Telah memilih",
    dbz: " mata uang saat ini",
    cxxz: "Pilih Ulang",
    dzkbz: "Alamat di buku alamat tidak cukup, harap hubungi administrator",
    qxzcrdbz: "Harap pilih mata uang yang akan disetor terlebih dahulu",
    qxzcbwl: "Harap pilih jaringan setor koin",
    qxztqdbz: "Harap pilih mata uang yang akan ditarik terlebih dahulu",
    cr: "Setor Ke",
    tq: "Tarik Dari",
    cbxq: "Detail Setor Koin",
    txxq: "Detail Penarikan",
    usdttxjl: "Riwayat Penarikan {coinName}",
    qbtxjl: "Semua Riwayat Penarikan",
    zyxx: "Informasi Penting: Anda hanya dapat mengirim {coinName} ke alamat ini, jika mengirim mata uang digital lainnya, Anda akan kehilangan dana ini.",
    jzjcr: "Setor dana ke",
    smewm: "Pindai kode QR atau salin informasi berikut ke platform pengirim",
    xcdzcz: "Menyetor mata uang non-{coinName} ke alamat ini akan menyebabkan aset Anda tidak dapat dipulihkan",
    znhycz: "Saat ini tidak mendukung setor kontrak pintar, setor paket, setor hadiah blok",
    usdtcbdz: "Alamat Setor Koin {coinName}",
    fzdz: "Salin Alamat",
    usdtdz: "Alamat {coinName}",
    zxcbe: "Jumlah Setor Minimum",
    zytx2:
        "Informasi Penting: Harap pastikan platform penerima mendukung jaringan {coinName} yang Anda pilih, jika tidak Anda akan kehilangan dana ini.",
    kytxwl: "Jaringan Penarikan yang Tersedia untuk {coinName}",
    xzwl: "Pilih Jaringan",
    dzym: "Alamat {coinName}",
    srdz: "Masukkan alamat atau pilih dari buku alamat",
    jymm: "Kata Sandi Trading",
    qsrjymm: "Silakan masukkan kata sandi trading",
    zxtbe: "Jumlah Penarikan Minimum: {minAmount}",
    ky: "Tersedia: ",
    zhztbxe: "Batas Penarikan Total Akun",
    gjxyddj:
        "Berdasarkan level verifikasi Anda, Anda hanya dapat menarik dalam jumlah terbatas dalam 24 jam. Batas ini akan menghitung konversi USD ke mata uang digital pilihan Anda.",
    scbdjd:
        "Karena volatilitas harga koin yang besar, biaya untuk mata uang ini adalah biaya mengambang, berdasarkan harga koin rata-rata 24 jam sebelumnya, dikenakan biaya setara 0.2-0.2 USDT. Tingkatkan biaya untuk mempercepat kecepatan penerimaan",
    yqdz: "Diharapkan Diterima",
    yqdzwf: "Jumlah yang diharapkan tidak boleh negatif",
    sfrz: "Verifikasi Identitas",
    ggyzm: "Kode Verifikasi Google",
    dxyzm: "Kode Verifikasi SMS",
    yxyzm: "Kode Verifikasi Email",
    qsryzm: "Silakan masukkan kode verifikasi",
    fsyzm: "Kirim Kode Verifikasi",
    cxfs: "Kirim Ulang",
    tj: "Kirim",
    qxztxwl: "Harap pilih jaringan penarikan",
    qsrdz: "Silakan masukkan alamat",

    qxzdz: "Harap pilih alamat",
    qxzyzfs: "Harap pilih satu metode verifikasi identitas",
    qsrtqsl: "Silakan masukkan jumlah yang ditarik",
    qwcyz: "Harap selesaikan verifikasi",
    qqrbdsj: "Harap konfirmasi terlebih dahulu apakah ponsel terikat",
    qqrbdyx: "Harap konfirmasi terlebih dahulu apakah email terikat",
    fzcg: "Berhasil Disalin!",
    tbcg: "Penarikan Berhasil",
    usdttxdz: "Alamat Penarikan {coinName}",
    lmc: "Nama Rantai:",
    qtj: "*Harap tambahkan",
    dz: "alamat",
    fei: "Bukan",
    zjds: " alamat dapat menyebabkan kehilangan aset",
    yzfs: "Metode Verifikasi",
    yzm: "Kode Verifikasi",
    remark: "Keterangan",
    qsrremark: "Silakan masukkan keterangan",
    tjdzcg: "Berhasil Menambahkan Alamat",
    qxxzyzfs: "Harap pilih metode verifikasi terlebih dahulu",
    qsrtxdz: "Silakan masukkan alamat penarikan",

    stop: "Jeda",

    // status
    qr0: "0 Konfirmasi",
    qr1: "1 Konfirmasi",
    dqr: "Menunggu Konfirmasi",
    czcg: "Setor Berhasil",
    hzz: "Transfer dalam Proses",
    ywc: "Selesai",
    sb: "Gagal",
    zzcl: "Sedang Diproses",
    ddsh: "Menunggu Tinjauan",
    txcg: "Penarikan Berhasil",
    cxcg: "Berhasil Dibatalkan",
    ddtx: "Menunggu Penarikan",
    txsb: "Penarikan Gagal",
    slsb: "Gagal Di-chain",
    dfk: "Menunggu Pembayaran",
    yfk: "Telah Dibayar",
    yqx: "Dibatalkan",
    ssz: "Dalam Banding",
    gdfrhz: "Transfer Bagi Hasil Copy Trading",
    hyzh_to_gdzh: "Akun Kontrak - Akun Copy Trading",
    gdzh_to_hyzh: "Akun Copy Trading - Akun Kontrak",
    ddcl: "Menunggu Pemrosesan",
    cg: "Berhasil",

    // dialog
    zchz: "Transfer Aset",
    ljhz: "Transfer Sekarang",
    cong: "Dari",
    dao: "Ke",
    qtzh: "Akun Lain",
    qxzbz: "Harap pilih mata uang",
    qsrsl: "Silakan masukkan jumlah",
    khz: "Dapat Ditransfer:",
    ye: "Saldo:",
    hzcg: "Transfer Berhasil",

    // h5
    zcgl: "Ikhtisar Aset",
    xrzx: "Eksklusif Pendatang Baru",
    zzc: "Total Aset",
    jryk: "Laba/Rugi Hari Ini",
    zgjz: "Hadiah Pendatang Baru senilai hingga 3200 USDT menanti Anda",
    zhrj: "Danai Akun Anda",
    xzrjfs: "Setelah mendanai, Anda dapat membeli mata uang digital, Anda dapat memilih metode pendanaan sesuai situasi aktual",
    czszhb: "Setor Mata Uang Digital",
    yyydszhb: "Setor mata uang digital yang telah Anda miliki di platform lain ke akun Biking.",
    czfb: "Setor Mata Uang Fiat",
    czzhz:
        "Setor mata uang fiat yang telah Anda miliki ke akun Biking, mendukung berbagai metode pembayaran seperti kartu bank, transfer, dll.",
    maibi: "Beli Koin",
    tgdsfmb: "Beli mata uang digital melalui kartu bank, P2P, pihak ketiga, dll.",
    yqyl: "Undang dan Dapat Hadiah",
    yqfy: "Undang teman dan nikmati komisi 20%",
    cxzzn: "Panduan Pemula",
    czzh: "Buat Akun Biking",
    hdxrj: "Dapatkan Bonus Pendatang Baru 100USDT",
    ck: "Setoran",
    tzndzh: "Investasikan akun Anda, mulai perjalanan Anda, mendukung berbagai metode pembayaran",
    wcsfrz: "Selesaikan Verifikasi Identitas (KYC)",
    hgzh: "Selesaikan Verifikasi Identitas (KYC) dan jadilah akun yang compliant",
    ksjy: "Mulai Trading",
    tsgd: "Jual, beli, atau salin trading, jelajahi lebih banyak",
    ksndlc: "Mulai Perjalanan Anda",
    kjydjmhb: "Kripto yang Dapat Diperdagangkan",
    jmhb: "Total nilai kripto adalah $1.228485 triliun",
    zengjin: "Bonus",
    lc: "Keuangan",
    mb: "Beli Koin",
    lsjl: "Riwayat",
    zclb: "Daftar Aset",
    shaixuan: "Filter",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/property/ba.js